import { PaymentDetailList } from '@/features/InvoiceReport/Edit/components/Drawer/OcrReflectionDrawer/Components/PaymentDetailList';
import { PaymentDetailSummary } from '@/features/InvoiceReport/Edit/components/Drawer/OcrReflectionDrawer/Components/PaymentDetailSummary';
import { OcrInferenceResult } from '@/features/InvoiceReport/Edit/components/type';
import { useTranslation } from '@/i18n';
import { Checkbox } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, useMemo } from 'react';
import styles from './OcrReflectionDetailsForm.module.scss';

const cx = classNames.bind(styles);
export type PaymentDetailSummaryProps = {
  transactionList?: OcrInferenceResult['invoiceTransactions'];
};

type Props = {
  ocrInferenceResult: OcrInferenceResult | null;
  willOverwriteTransactions?: boolean;
  canDisplayDrExcise?: boolean;
  isChecked: boolean;
  setIsChecked: (value: boolean) => void;
};

const InnerOcrReflectionDetailsForm: FC<Props> = ({
  ocrInferenceResult,
  willOverwriteTransactions = false,
  canDisplayDrExcise = false,
  isChecked,
  setIsChecked,
}) => {
  const { t } = useTranslation();

  const overwriteWarningMessage = useMemo(
    () => ({
      message: t('payment_request_edit_ocr.drawer.overwrite_warning'),
      enabled: willOverwriteTransactions,
    }),
    [t, willOverwriteTransactions]
  );

  return (
    <div className={cx(styles['container'])}>
      <div className={cx(styles['title'])}>{t('payment_detail_title')}</div>
      <div className={cx(styles['checkbox-and-summary'])}>
        <div className={cx(styles['checkbox-wrapper'])}>
          <Checkbox
            checked={isChecked}
            label={t('payment_detail_checkbox_label')}
            onChange={(e) => setIsChecked(e.target.checked)}
          />
        </div>
        <div className={cx(styles['summary-wrapper'])}>
          <PaymentDetailSummary
            detailsTotalAmountValue={
              ocrInferenceResult?.transactionDetailTotalValue
            }
            taxAmountValue={ocrInferenceResult?.exciseValue}
            totalAmountValue={ocrInferenceResult?.paymentRequestTotalValue}
            withholdingIncomeTaxValue={
              ocrInferenceResult?.withholdingIncomeTaxValue
            }
            hasWithholdingIncomeTax={
              ocrInferenceResult?.apPayee?.isWithholdingTax
            }
            subtotal10={ocrInferenceResult?.subtotal10}
            subtotal8={ocrInferenceResult?.subtotal8}
            subtotalTaxFree={ocrInferenceResult?.subtotalTaxFree}
          />
        </div>
      </div>

      <PaymentDetailList
        isSelected={isChecked}
        transactionList={ocrInferenceResult?.invoiceTransactions}
        inferences={ocrInferenceResult?.inferences ?? []}
        warningMessage={overwriteWarningMessage}
        canDisplayDrExcise={canDisplayDrExcise}
      />
    </div>
  );
};
InnerOcrReflectionDetailsForm.displayName = 'InnerOcrReflectionApplicationForm';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const OcrReflectionDetailsForm = memo(
  InnerOcrReflectionDetailsForm
) as typeof InnerOcrReflectionDetailsForm;
